import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import * as _ from "lodash";
import * as angular from "angular";
import { EntityConfigService } from "../services/entity-config-service";
import { BulkUploadService } from "../services/bulk-upload-service";
import { NotifyService } from "../services/notify-service";
import { StorageService } from "../services/storage-service";
import { EntityService } from "../services/entity-service";
import { CurrencyConversionService } from "../services/currency-conversion-service";
import { AclService } from "../services/acl-service";


export interface IRLBulkImportUpdateScope extends ng.IScope {
    mode: number;
}

export function RLBulkImportUpdate() {
    var directive: ng.IDirective = {
        restrict: "EA",
        template: require("/assets/app/templates/bulk-import-update.html"),
        controllerAs: "biuVM",
        controller: BulkImportUpdateController,
        scope: {
            mode: "="
        },
        bindToController: true,
        link: (scope: IRLBulkImportUpdateScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: BulkImportUpdateController) => { }
    }
    return directive;
}

export class BulkImportUpdateController {
    static $inject = ["$scope", "$location", "$window", "$q", "$log", "$sce", "entityConfigService", "bulkUploadService", "notifyService", "storage", "entityService", "currencyConversionService", "aclService"];

    mode: number;
    initialized: boolean
    selectedCharTypeID: number;
    selectedTemplateID: number;
    charTypes: Models.ICharacteristicType[];
    parentCharTypes: Models.ICharacteristicType[];
    assocCharTypes: Models.ICharacteristicType[];
    templates: Models.ICharacteristicTemplate[];
    destinationCols: Models.ICharacteristic[];
    templateChars: Models.ICharacteristicMetaData[];
    lovMetaDatas: { [charValueSourceID: string]: Models.ICharLovMetaData };
    templateMetaData: Models.ICharacteristicMetaDataCollection;
    validationResults: { [key: number]: Models.IBulkUploadValidationResult[] };
    token: string;
    headerMappingRows: Models.IBulkUploadValidationResult[];
    savedHeaderMappingRow: Models.IBulkUploadValidationResult[];
    validationResultRow: Models.IBulkUploadValidationResult[];
    pickedFile: IFilestackPickFile;
    selectedFileName: string;
    showHeaderMapping: boolean;
    validHeaderMapping: boolean;
    editMode: boolean;
    visibility: number;
    charDatas: { [key: string]: Models.ICharDataValue[] };
    selectedEntityCharData: Models.ICharDataCollection;
    selectedColumnEntityCharData: Models.ICharDataCollection;
    isFileDataValidated: boolean;
    stgDivID: number;
    mappingName: string;
    savedBulkUploadHeaderMappings: Models.ISavedBulkUploadHeaderMapping[];
    savedBulkUploadHeaderMappingsKey: string;
    selectedMapping: Models.ISavedBulkUploadHeaderMapping;
    allRowsValid: boolean;
    columnHeaderCharacteristicTagLabel: string;
    columnHeaderIndex: number;
    allowToUpload: boolean;
    selectedParentCharTypeID: number;
    isColumnEdit: boolean;
    showParentSelectionPanel: boolean;
    selectParentMode: boolean;
    showSelectParent: boolean;
    showSelectedParent: boolean;
    selectedParentRecID: number;
    selectedParentTitle: string;
    showParentSearchModal: boolean;
    childCharTypeIDs: { [id: string]: number };
    parentCharTypeIDs: { [id: string]: number };
    notAllowBulkUploadCharTypeIDs: { [id: string]: number };
    errorOccured: boolean;
    selectedParentTemplate: string;
    parentTemplates: Models.ICharacteristicTemplate[];
    allowMultiple: boolean;
    allowMultipleParentCharTypeIDs: { [id: string]: number };
    allChecked: boolean;
    singleItemSelected: boolean;
    showColumns: string[];
    canCreate: boolean;
    showAdvance: boolean;
    selectedAssociationCharTypeID: number;
    assocRelDirection: number;
    localCurrency: string;
    selectedPartyCharTypeID: number;
    bulkImportingParties: boolean;
    allowDownloadTemplate: boolean;
    showJobProgressStatus: boolean;
    jobId: string;
    jobTitle: string;
    progressStatus: string;
    resultMessage: string;
    selectedRecIdTitlePairs: Models.IKeyValuePair<number, string>[];

    listValues: Models.ICharacteristicValue[];
    listRels: Models.ICharacteristicValueHierarchy[];
    charValSourceListValues: Models.ICharacteristicValue[];
    showMapColumnLOVs: boolean;
    mapColumnIndex: number;
    columnLOVs: string[];
    currentColumnLovMapping: { [key: string]: Models.ICharacteristicValue };
    validLOVMapping: boolean;
    savedBulkUploadColumnLovMappingsKey: string;
    selectedColumnCharIDForMapping: number;
    selectedColumnCharValueSetID: string;
    lovMappingName: string;
    savedBulkUploadColumnLovMappings: Models.ISavedBulkUploadColumnLovMapping[];
    selectedColumnLovMapping: Models.ISavedBulkUploadColumnLovMapping;
    selectedRecIDsForColLOVMapping: number[];
    requiredTemplateCharacteristicList: { [key: number]: boolean };
    //		bulkImportingAmounts: boolean;
    selectedDateFormat: string;
    bulkUpdateMode: boolean;
    moduleLevelCharTypeIDSelected: boolean;
    preValidationErrorMessage: { [key: number]: string };
    hasPreValidationError: boolean;

    constructor(private $scope: ng.IScope,
        private $location: ng.ILocationService,
        private $window: ng.IWindowService,
        private $q: ng.IQService,
        private $log: ng.ILogService,
        private $sce: ng.ISCEService,
        private entityConfigService: EntityConfigService,
        private bulkUploadService: BulkUploadService,
        private notifyService: NotifyService,
        private storage: StorageService,
        private entityService: EntityService,
        private currencyConversionService: CurrencyConversionService,
        private aclService: AclService) {

        this.selectedCharTypeID = null;
        this.selectedTemplateID = null;
        this.entityConfigService = entityConfigService;
        this.charTypes = [];
        this.parentCharTypes = [];
        this.assocCharTypes = [];
        this.templates = [];
        this.destinationCols = [];
        this.validationResults = {};
        this.token = "";
        this.pickedFile = null;
        this.showHeaderMapping = false;
        this.validHeaderMapping = false;
        this.editMode = false;
        this.visibility = 1;
        this.templateMetaData = null;
        this.charDatas = {};
        this.selectedEntityCharData = null;
        this.selectedColumnEntityCharData = null;
        this.isFileDataValidated = false;
        this.stgDivID = 0;
        this.mappingName = "";
        this.savedBulkUploadHeaderMappings = [];
        this.savedHeaderMappingRow = [];
        this.savedBulkUploadHeaderMappingsKey = "bulkUploadHeaderMapping_" + Consts.userDivAppUrlHash;
        this.selectedMapping = null;
        this.allRowsValid = false;
        this.columnHeaderCharacteristicTagLabel = "";
        this.columnHeaderIndex = 0;
        this.allowToUpload = false;
        this.selectedParentCharTypeID = null;
        this.isColumnEdit = false;
        this.selectParentMode = false;
        this.showSelectedParent = false;
        this.showSelectParent = false;
        this.selectedParentRecID = 0;
        this.selectedParentTitle = "";
        this.showParentSearchModal = false;
        this.childCharTypeIDs = <{ [id: string]: number }>Consts.ChildCharTypes.IDs;
        this.parentCharTypeIDs = <{ [id: string]: number }>Consts.ModuleLevelCharTypes.IDs;
        this.showParentSelectionPanel = false;
        this.lovMetaDatas = {};
        this.notAllowBulkUploadCharTypeIDs = <{ [id: string]: number }>Consts.NotBulkUploadCharTypes.IDs;
        this.errorOccured = false;
        this.selectedParentTemplate = "";
        this.parentTemplates = [];
        this.allowMultiple = true;
        this.allowMultipleParentCharTypeIDs = <{ [id: string]: number }>Consts.AllowMultipleParentCharTypes.IDs;
        this.allChecked = false;
        this.singleItemSelected = false;
        this.showColumns = [];
        this.canCreate = false;
        this.showAdvance = false;
        this.selectedAssociationCharTypeID = null;
        this.assocRelDirection = 1;
        this.localCurrency = "";
        this.selectedPartyCharTypeID = 100;
        this.bulkImportingParties = false;
        this.allowDownloadTemplate = false;
        this.showJobProgressStatus = false;
        this.selectedRecIdTitlePairs = [];
        this.listValues = [];
        this.listRels = [];
        this.charValSourceListValues = [];
        this.showMapColumnLOVs = false;
        this.columnLOVs = [];
        this.currentColumnLovMapping = {};
        this.validLOVMapping = false;
        this.savedBulkUploadColumnLovMappingsKey = "bulkUploadColLovMapping_" + Consts.userDivAppUrlHash;
        this.selectedRecIDsForColLOVMapping = [];
        this.requiredTemplateCharacteristicList = {};
        //this.bulkImportingAmounts = false;
        this.selectedDateFormat = "mm/dd/yyyy";
        this.bulkUpdateMode = false;
        this.Init();
        this.moduleLevelCharTypeIDSelected = false;
        this.preValidationErrorMessage = {};
        this.hasPreValidationError = false;

        $scope.$watch(() => this.selectedCharTypeID, (newValue, oldValue) => {
            if (newValue != oldValue) {
                this.CharTypeChanged();
            }
        });

        $scope.$watch(() => this.selectedTemplateID, (newValue, oldValue) => {
            if (newValue != oldValue) {
                if (newValue > 0) {
                    this.allowToUpload = false;
                    this.TemplateChanged();
                }
            }
        });

        $scope.$watch(() => this.selectedMapping, (newValue, oldValue) => {
            if (newValue != oldValue && newValue != null) {
                this.UpdateHeaderMapping();
            }
        });

        $scope.$watch(() => this.pickedFile,
            (newValue, oldValue) => {
                if (newValue != oldValue && newValue != null) {
                    this.errorOccured = false;
                    this.selectedFileName = newValue[0].key;
                    if (this.selectedCharTypeID != this.selectedPartyCharTypeID) {
                        this.ValidateHeaders();
                    }
                    else {
                        this.ValidatePartyTemplate();
                    }
                }
            }, true);

        $scope.$watch(() => this.selectedParentCharTypeID, (newValue, oldValue) => {
            if (newValue != oldValue) {
                this.ParentCharTypeChanged();
            }
        });

        $scope.$watch(() => this.selectedAssociationCharTypeID, (newValue, oldValue) => {
            if (newValue != oldValue) {
                if (newValue > 0) {
                    this.allowToUpload = true;
                    this.allowDownloadTemplate = true;
                }
            }
        });

        $scope.$watch(() => this.showParentSearchModal, (newValue, oldValue) => {
            if (!newValue && newValue != oldValue) {
                this.showSelectedParent = true;
                this.allowToUpload = true;

                if (this.selectedRecIdTitlePairs.length == 1) {
                    var singleEntityID = Utils.IdBuilder.buildEntityID(this.stgDivID, this.selectedParentCharTypeID, this.selectedRecIdTitlePairs[0].key);
                    this.notifyService.startProgress();
                    return this.entityService.getEntity(singleEntityID)
                        .then((result) => {
                            this.selectedParentTitle = result.record.title;
                        })
                        .finally(() => {
                            this.notifyService.endProgress();
                        });
                }
                else {
                    if (this.selectedRecIdTitlePairs.length > 1) {
                        this.selectedParentTitle = "Multiple Records Selected";
                    }
                }
            }
        });

        $scope.$watch(() => this.progressStatus, (newValue, oldValue) => {
            if (newValue != oldValue && (newValue == "Done")) {
                this.showJobProgressStatus = false;
                this.errorOccured = false;
                var bulkUploadValidationResult: Models.IBulkUploadFileValidation = Utils.JsonUtil.Parse(this.resultMessage, {});
                this.preValidationErrorMessage = {};
                this.hasPreValidationError = false;
                if (!_.isEmpty(bulkUploadValidationResult)) {
                    this.errorOccured = bulkUploadValidationResult.ErrorOccured;
                    this.validationResults = {};
                    if (this.errorOccured) {
                        //console.log(bulkUploadValidationResult.PreValidationErrorMessage);
                        this.preValidationErrorMessage = bulkUploadValidationResult.PreValidationErrorMessage;
                        if (!_.isEmpty(this.preValidationErrorMessage)) {
                            this.hasPreValidationError = true;
                        }
                        this.allRowsValid = false;
                        this.showHeaderMapping = false;
                        this.isFileDataValidated = true;
                        this.notifyService.notifyError("Error Validating File Data.");
                    }
                    else {
                        this.validationResults = {};
                        this.token = bulkUploadValidationResult.Token;
                        var fileValidationResult = bulkUploadValidationResult.ValidationResult;
                        var validationResultKeys = _.keys(fileValidationResult).map((key) => _.parseInt(key));
                        _.forEach(validationResultKeys, (key) => {
                            var inValidRow: Models.IBulkUploadValidationResult[] = [];

                            _.forEach(fileValidationResult[key], (row) => {
                                var inValidCharItem: Models.IBulkUploadValidationResult = {
                                    characteristicID: row.CharacteristicID,
                                    charValue: row.CharValue,
                                    recCharID: row.RecCharID,
                                    isHidden: row.IsHidden,
                                    isValid: row.IsValid
                                }
                                inValidRow.push(inValidCharItem);
                            });

                            this.validationResults[key] = inValidRow;
                        });
                        this.headerMappingRows = this.validationResults[0];
                        this.showHeaderMapping = true;
                        this.isFileDataValidated = true;
                        this.AreHeadersMapped();
                        this.AreAllRowsValid();
                        this.notifyService.notifySuccess("Validate File Data successful.");
                    }
                }
                else {
                    //Something went wrong
                    this.errorOccured = true;
                    this.allRowsValid = false;
                    this.notifyService.notifyError("Error Validating File Data.");
                }
            }
        });

        $scope.$watch(() => this.showMapColumnLOVs, (newValue, oldValue) => {
            if (newValue != oldValue && newValue) {
                this.MapColumnLOVs();
            }
        });

        $scope.$watch(() => this.selectedColumnLovMapping, (newValue, oldValue) => {
            if (newValue != oldValue && newValue != null) {
                this.UpdateColumnLovMapping();
            }
        }, true);
    }

    Init() {
        this.notifyService.startProgress();
        this.entityConfigService.getCharacteristicTypes()
            .then((result) => {
                this.charTypes = [];
                _.forEach(result, (ct) => {
                    if (!_.any(this.notAllowBulkUploadCharTypeIDs, (id) => id == ct.charTypeID)) {
                        this.charTypes.push(ct);
                    }
                });

                var partyCharType: Models.ICharacteristicType = {
                    charTypeID: this.selectedPartyCharTypeID,
                    charTypeName: 'Party',
                    seqNumber: 100
                };
                this.charTypes.push(partyCharType);
                this.notifyService.endProgress();
            });
    }

    CharTypeChanged() {
        this.selectedTemplateID = null;
        this.showSelectedParent = false;
        this.showSelectParent = false;
        this.showParentSelectionPanel = false;
        this.parentCharTypes = [];
        this.assocCharTypes = [];
        this.allowToUpload = false;
        this.allowMultiple = true;
        this.bulkImportingParties = false;
        this.moduleLevelCharTypeIDSelected = false;
        //this.bulkImportingAmounts = false;

        if (this.selectedCharTypeID == this.selectedPartyCharTypeID) {
            this.bulkImportingParties = true;
            this.parentCharTypes = [];
            this.assocCharTypes = [];
            this.selectedAssociationCharTypeID = null;

            _.forEach(this.charTypes, ct => {
                if (_.any(this.parentCharTypeIDs, (id) => id == ct.charTypeID)) {
                    this.assocCharTypes.push(ct);
                }
            });
        }
        else {
            //This is only when selected chartype is Amount
            if (this.selectedCharTypeID == Consts.CharTypeIDs.amount) {
                this.parentCharTypeIDs = {};
                this.parentCharTypeIDs[Consts.CharTypeIDs.invoice] = Consts.CharTypeIDs.invoice;
            }

            if (_.any(this.parentCharTypeIDs, (id) => id == this.selectedCharTypeID)) {
                this.moduleLevelCharTypeIDSelected = true;
            }
            else {
                this.moduleLevelCharTypeIDSelected = false;
            }

            this.notifyService.startProgress();
            return this.entityConfigService.getCharacteristicTemplates(this.selectedCharTypeID)
                .then((result) => {
                    this.templates = _.filter(result, t => Utils.AclUtil.hasReadAccess(this.aclService.acls, t.acl));
                    this.parentCharTypes = [];
                    this.assocCharTypes = [];
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        }
    }

    ParentCharTypeChanged() {
        this.showSelectedParent = false;
        this.allChecked = false;
        this.selectedRecIdTitlePairs = [];

        if (_.any(this.allowMultipleParentCharTypeIDs, (id) => id == this.selectedCharTypeID)) {
            this.allowMultiple = true;
        }
        this.showAdvance = true;
        this.showSelectParent = true;
    }

    TemplateChanged() {
        this.showSelectedParent = false;
        this.showSelectParent = false;
        this.showParentSelectionPanel = false;
        this.selectedParentCharTypeID = null;
        this.parentCharTypes = [];
        this.assocCharTypes = [];
        this.allowDownloadTemplate = true;

        if (this.mode == 1) {
            this.notifyService.startProgress();
            if (_.any(this.parentCharTypeIDs, (id) => id == this.selectedCharTypeID)) {
                this.allowToUpload = true;
            }
            else {
                this.allowToUpload = false;
            }

            var cmdAcls: _.Dictionary<string> = {};

            var promise1 = this.entityConfigService.getCharacteristicTemplate(this.selectedCharTypeID, this.selectedTemplateID)
                .then((result) => {
                    this.templateMetaData = result;
                    this.templateChars = result.characteristicMetaDatas;
                    cmdAcls = Utils.AclUtil.getDataEntityAcls(result);
                    var promises: ng.IPromise<any>[] = [];
                    _.forEach(this.templateChars, (chr) => {
                        //if (chr.visibilityIndicator > 0) {
                        if (Utils.AclUtil.hasReadAccess(this.aclService.acls, cmdAcls[chr.characteristicID])) {
                            this.destinationCols.push(chr);
                        }
                        if (chr.charValueSourceID) {
                            var promise = this.entityService.getCharLovMetaData(chr.charValueSourceID, chr.charValueSetID)
                                .then((result2) => {
                                    this.lovMetaDatas[chr.charValueSourceID] = result2;
                                });
                            promises.push(promise);
                        }
                    });
                    return this.$q.all(promises);
                });

            var promise2 = this.entityConfigService.getRelatedConfigurationParentCharacteristicTypes(this.selectedCharTypeID)
                .then((results) => {
                    _.forEach(results, (result) => {
                        var assocCharTypeID = result.charTypeID;
                        if (_.any(this.parentCharTypeIDs, (id) => id == assocCharTypeID)) {
                            if (!_.any(this.parentCharTypes, (pct) => pct.charTypeID == assocCharTypeID)) {
                                var parentCharType = _.find(this.charTypes, (ct) => ct.charTypeID == assocCharTypeID);
                                this.parentCharTypes.push(parentCharType);
                            }
                        }
                    });
                })
                .finally(() => {
                    if (this.parentCharTypes.length > 0) {
                        this.showParentSelectionPanel = true;
                    }
                    else {
                        this.showParentSelectionPanel = false;
                    }
                });

            var promise3 = this.entityConfigService.getRelatedConfigurationCharacteristicTypes(this.selectedCharTypeID)
                .then((result) => {
                    if (!_.any(this.allowMultipleParentCharTypeIDs, a => a == this.selectedCharTypeID)) {
                        _.forEach(result, (r) => {
                            if (_.any(this.charTypes, (ct) => ct.charTypeID == r.charTypeID)) {
                                var assocCharType = _.find(this.charTypes, (ct) => ct.charTypeID == r.charTypeID);
                                this.assocCharTypes.push(assocCharType);
                            }
                        });
                    }
                });

            var promise4 = this.currencyConversionService.getCompanyCurrency()
                .then((result) => {
                    this.localCurrency = result.data;
                });

            this.$q.all([promise1, promise2, promise3, promise4])
                .then(() => {
                    this.requiredTemplateCharacteristicList = {};
                    if (_.any(this.allowMultipleParentCharTypeIDs, a => a == this.selectedCharTypeID)) {
                        this.assocCharTypes = _.cloneDeep(this.parentCharTypes);
                    }
                    else {
                        _.forEach(this.parentCharTypes, (pr) => {
                            if (!_.any(this.assocCharTypes, ac => ac.charTypeID == pr.charTypeID)) {
                                this.assocCharTypes.push(pr);
                            }
                        });
                    }

                    _.forEach(this.templateChars, tchr => {
                        if (tchr.requiredIndicator == 1 && Utils.AclUtil.hasReadAccess(this.aclService.acls, cmdAcls[tchr.characteristicID])) { // tchr.visibilityIndicator != 0) {
                            this.requiredTemplateCharacteristicList[tchr.characteristicID] = true;
                        }
                        else {
                            this.requiredTemplateCharacteristicList[tchr.characteristicID] = false;
                        }

                    });
                    this.notifyService.endProgress();
                });
        }
        else {
            this.notifyService.startProgress();

            var promise1 = this.entityConfigService.getCharacteristicTemplate(this.selectedCharTypeID, this.selectedTemplateID)
                .then((result) => {
                    this.templateMetaData = result;
                    this.templateChars = result.characteristicMetaDatas;

                    var promises: ng.IPromise<any>[] = [];
                    _.forEach(this.templateChars, (chr) => {
                        this.destinationCols.push(chr);
                        if (chr.charValueSourceID) {
                            var promise = this.entityService.getCharLovMetaData(chr.charValueSourceID, chr.charValueSetID)
                                .then((result2) => {
                                    this.lovMetaDatas[chr.charValueSourceID] = result2;
                                });
                            promises.push(promise);
                        }
                    });
                    return this.$q.all(promises);
                });

            var promise2 = this.currencyConversionService.getCompanyCurrency()
                .then((result) => {
                    this.localCurrency = result.data;
                });

            this.$q.all([promise1, promise2])
                .then(() => {
                    this.allowToUpload = true;
                    this.notifyService.endProgress();
                });

        }
    }

    ShowParentSearchModal() {
        this.showParentSearchModal = true
    }

    SelectedParent(selectedParent: string) {

        var pair = selectedParent.split("|");
        if (pair.length == 2) {
            this.selectedParentRecID = _.parseInt(pair[0]);
            this.selectedParentTitle = pair[1];
            this.showSelectedParent = true;
            this.showParentSearchModal = false;
            this.allowToUpload = true;
        }
    }

    SelectedParents() {
        this.selectedParentTitle = "Multiple Parent Selected";
        this.showSelectedParent = true;
        this.showParentSearchModal = false;
        this.allowToUpload = true;
    }

    DownLoadCSVTemplate() {
        var url = "/api/bulkupload/downloadcsvtemplate?";
        url = url + 'mode=' + this.mode;
        url = url + '&charTypeID=' + this.selectedCharTypeID;
        if (this.selectedTemplateID == null) {
            url = url + '&templateID=0';
        }
        else {
            url = url + '&templateID=' + this.selectedTemplateID;
        }


        if (this.selectedAssociationCharTypeID > 0) {
            url = url + '&addAssociationColumns=' + true;
        }
        else {
            url = url + '&addAssociationColumns=' + false;
        }

        if (this.selectedCharTypeID == this.selectedPartyCharTypeID) {
            url = url + '&downloadPartyTemplate=' + true;
        }
        else {
            url = url + '&downloadPartyTemplate=' + false;
        }
        return url;
    }

    Reset() {
        this.selectedCharTypeID = null;
        this.selectedTemplateID = null;
        this.selectedFileName = "";
        this.pickedFile = null;
        this.showHeaderMapping = false;
        this.validHeaderMapping = false;
        this.editMode = false;
        this.isFileDataValidated = false;
        this.allRowsValid = false;
        this.mappingName = "";
        this.columnHeaderCharacteristicTagLabel = "";
        this.columnHeaderIndex = 0;
        this.selectedEntityCharData = null;
        this.selectedColumnEntityCharData = null;
        this.templateMetaData = null;
        this.charTypes = [];
        this.parentCharTypes = [];
        this.templates = [];
        this.destinationCols = [];
        this.validationResults = {};
        this.savedBulkUploadHeaderMappings = [];
        this.savedHeaderMappingRow = [];
        this.selectedMapping = null;
        this.selectParentMode = false;
        this.showSelectedParent = false;
        this.showSelectParent = false;
        this.selectedParentRecID = 0;
        this.selectedParentTitle = "";
        this.showParentSearchModal = false;
        this.showParentSelectionPanel = false;
        this.errorOccured = false;
        this.allowToUpload = false;
        this.parentTemplates = [];
        this.allowMultiple = true;
        this.showAdvance = false;
        this.selectedRecIdTitlePairs = [];
        this.selectedAssociationCharTypeID = null;
        this.headerMappingRows = [];
        this.bulkImportingParties = false;
        this.allowDownloadTemplate = false;
        this.moduleLevelCharTypeIDSelected = false;
        //this.bulkImportingAmounts = false;
        this.Init();
    }

    RemoveColumn(index: number) {
        var tmd = this.templateMetaData.characteristicMetaDatas;
        var deletingRequiredColumn = false;
        var mode = this.mode;
        var cmdAcls = Utils.AclUtil.getDataEntityAcls(this.templateMetaData);

        _.each(this.validationResults, function (value: Models.IBulkUploadValidationResult[], key) {
            if (key == "0") {
                var getCharMetaData = _.find(tmd, (chr) => chr.characteristicID == value[index].characteristicID);
                if (getCharMetaData != undefined && getCharMetaData.requiredIndicator == 1 && Utils.AclUtil.hasReadAccess(this.aclService, cmdAcls[getCharMetaData.characteristicID])) { // getCharMetaData.visibilityIndicator != 0) {
                    if (mode == 1) {
                        deletingRequiredColumn = true;
                        return false;
                    }
                    else if (mode == 2 && getCharMetaData.tagLabel == "entity_id") {
                        deletingRequiredColumn = true;
                        return false;
                    }
                }
            }

            if (!deletingRequiredColumn) {
                if (_.isArray(value)) {
                    value[index].isHidden = true;
                }
            }
        });

        if (deletingRequiredColumn) {
            alert("You cannot remove a required characteristic field");
        }
        else {
            this.headerMappingRows[index].isHidden = true;
            this.headerMappingRows[index].isValid = true;
            this.AreHeadersMapped();
        }
    }

    ValidateHeaders() {
        this.notifyService.startProgress();

        delete this.validationResults;
        delete this.headerMappingRows;
        this.showHeaderMapping = false;
        delete this.selectedMapping;
        delete this.savedBulkUploadHeaderMappings;
        this.mappingName = "";

        var request: Models.IBulkUploadValidateFileHeadersRequest = {
            charTypeID: this.selectedCharTypeID,
            templateID: this.selectedTemplateID,
            selectedFileName: this.selectedFileName,
            mode: this.mode
        }

        return this.bulkUploadService.validateFileHeaders(request)
            .then((result) => {
                this.validationResults = result;
                this.headerMappingRows = result[0];
                
                var dupResult = this.FindDuplicateHeaders();
                if (dupResult.length > 0) {
                    alert("Your upload file has duplicate columns and cannot be ingested. Please remove the following columns and then reupload: " + dupResult.join('|'));
                    this.validHeaderMapping = false;
                }
                else {
                    this.showHeaderMapping = true;
                    this.AreHeadersMapped();
                    this.GetSavedHeaderMappings();
                    this.allRowsValid = false;
                    this.isFileDataValidated = false;

                    if (this.selectedAssociationCharTypeID > 0) {
                        var assocRecIDAsCharacteristic: Models.ICharacteristic = {
                            charTypeID: 0,
                            characteristicID: -10,
                            label: "Assoc Record ID",
                            tagLabel: "assoc_record_id",
                            maxLength: 100,
                            dataTypeID: 0,
                            systemIndicator: 0,
                            multipleIndicator: 0,
                            charValueSetID: "",
                            reportIndicator: 1,
                            description: ""
                        };

                        var assocRecNameAsCharacteristic: Models.ICharacteristic = {
                            charTypeID: 0,
                            characteristicID: -20,
                            label: "Assoc Record Name",
                            tagLabel: "assoc_record_name",
                            maxLength: 100,
                            dataTypeID: 0,
                            systemIndicator: 0,
                            multipleIndicator: 0,
                            charValueSetID: "",
                            reportIndicator: 1,
                            description: ""
                        };

                        if (!_.any(this.destinationCols, d => d.characteristicID == -10)) {
                            this.destinationCols.push(assocRecIDAsCharacteristic);
                        }

                        if (!_.any(this.destinationCols, d => d.characteristicID == -20)) {
                            this.destinationCols.push(assocRecNameAsCharacteristic);
                        }
                    }
                }
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    FindDuplicateHeaders() {
        var headerRowValues = this.headerMappingRows.map(row => row.charValue);

        var object = {};
        var dupResult = [];


        _.forEach(headerRowValues, (headerRow) => {
            if (!object[headerRow]) {
                object[headerRow] = 0;
            }
            object[headerRow] += 1;
        });

        for (var prop in object) {
            if (object[prop] >= 2) {
                dupResult.push(prop);
            }
        }

        return dupResult;
    }

    ValidatePartyTemplate() {
        this.validHeaderMapping = true;
        this.isFileDataValidated = true;
        this.allRowsValid = true;
    }

    CheckMapping(headerRow: Models.IBulkUploadValidationResult) {
        if (headerRow.characteristicID == null) {
            headerRow.isValid = false;
        }
        else {
            var mappedHeaders = _.filter(this.headerMappingRows, (cmd) => cmd.characteristicID == headerRow.characteristicID);
            if (mappedHeaders.length > 1) {
                headerRow.characteristicID = 0;
                alert("That field name is already mapped to another column. You can remove the mapping from the other column, then try again. Otherwise, select another field name.");
                headerRow.isValid = false;
            }
            else {
                headerRow.isValid = true;
            }
        }
        this.AreHeadersMapped();
    }

    AreHeadersMapped() {
        if (_.any(this.headerMappingRows, (hdr) => hdr.isValid == false)) {
            this.validHeaderMapping = false;
        }
        else {
            this.validHeaderMapping = true;
        }
    }

    ValidateFileData() {
        this.notifyService.startProgress();

        if (_.isEmpty(this.selectedDateFormat)) {
            this.selectedDateFormat = "mm/dd/yyyy";
        }

        this.errorOccured = false;
        if (this.selectedParentCharTypeID > 0 && this.selectedAssociationCharTypeID > 0) {
            if (this.selectedRecIdTitlePairs.length > 0) {
                this.assocRelDirection = 0;
            }
        }

        var request: Models.IBulkUploadValidateFileDataRequest = {
            charTypeID: this.selectedCharTypeID,
            assocCharTypeID: this.selectedAssociationCharTypeID,
            assocRelDirection: this.assocRelDirection,
            templateID: this.selectedTemplateID,
            selectedFileName: this.selectedFileName,
            selectedHeaders: this.headerMappingRows,
            mode: this.mode,
            selectedDateFormat: this.selectedDateFormat
        }

        return this.bulkUploadService.ValidateFileData(request)
            .then((result) => {
                this.showJobProgressStatus = true;
                this.jobId = result.jobID;
                this.jobTitle = result.jobTitle;
                this.notifyService.endProgress();
            });
    }

    Edit(key: number) {
        this.selectedEntityCharData = null;
        this.charDatas = {};
        this.validationResultRow = _.clone(this.validationResults[key], true);
        this.editMode = true;
        var entityID = Utils.IdBuilder.buildEntityID(this.stgDivID, this.selectedCharTypeID, key);
        var entityStatus: Models.IEntityStatus = {
            activeIndicator: 1,
            stepID: 1,
            processID: 1,
            divisionID: 10,
            stepName: "In Staging",
            deleteIndicator: 0,
            stepDescription: "",
            lockIndicator: 0,
            sequenceNumber: 1,
            createdBy: 1,
            createdAt: "",
            updatedBy: 1,
            updatedAt: ""
        };
        this.isColumnEdit = false;

        var filteredTempalteMetaData: Models.ICharacteristicMetaDataCollection = null;
        var filteredTemplateCharacteristicMetaDatas: Array<Models.ICharacteristicMetaData> = [];
        this.bulkUpdateMode = false;
        if (this.mode == 2) {
            this.bulkUpdateMode = true;
        }

        for (var i = 0; i < this.validationResultRow.length; i++) {
            var dataColumn = this.validationResultRow[i];

            if (this.headerMappingRows, (headerRow) => headerRow.characteristicID == dataColumn.characteristicID) {

                if (_.any(this.headerMappingRows, (headerRow) => headerRow.characteristicID == dataColumn.characteristicID)) {
                    var headerColumn = _.find(this.headerMappingRows, (headerRow) => headerRow.characteristicID == dataColumn.characteristicID);

                    if (headerColumn.isHidden == false) {
                        var valueID: number = undefined;
                        if (_.any(this.templateChars, (chr) => chr.characteristicID == headerColumn.characteristicID)) {
                            var charMD: Models.ICharacteristicMetaData = null;
                            var charDataValue: Models.ICharDataValue = null;
                            var charDataValues: Models.ICharDataValue[] = [];

                            charMD = _.find(this.templateChars, (chr) => chr.characteristicID == headerColumn.characteristicID);
                            var tagLabel = charMD.tagLabel;

                            if (charMD.dataTypeID == 14) {
                                var moneyValue: Models.ICharDataMoneyValue = Utils.JsonUtil.Parse(dataColumn.charValue, {});
                                if (_.isEmpty(moneyValue.locAmt)) {
                                    var moneyValue: Models.ICharDataMoneyValue = {
                                        locAmt: dataColumn.charValue,
                                        locSym: this.localCurrency
                                    };
                                    dataColumn.charValue = Utils.JsonUtil.Stringify(moneyValue);
                                }
                            } else if (charMD.dataTypeID == 5 && this.selectedDateFormat != "mm/dd/yyyy" && !_.isEmpty(dataColumn.charValue)) {
                                var dateValue = this.ConvertDateValueToUSDateFormat(dataColumn.charValue);
                                dataColumn.charValue = dateValue;
                            }

                            if (charMD.charValueSourceID != null) {
                                var charValueLbls = dataColumn.charValue.split("|");

                                _.forEach(charValueLbls, (charValueLbl) => {
                                    _.foreachGraph(this.lovMetaDatas[charMD.charValueSourceID].listOfValues, (lov) => lov.childValues, (lov) => {
                                        if (lov.characteristicValueLabel == charValueLbl) {
                                            valueID = lov.characteristicValueID;
                                        }
                                    });

                                    charDataValue = {
                                        charID: headerColumn.characteristicID,
                                        value: charValueLbl,
                                        recCharID: dataColumn.recCharID,
                                        valueID: valueID
                                    };

                                    charDataValues.push(charDataValue);
                                });
                            }
                            else {
                                charDataValue = {
                                    charID: headerColumn.characteristicID,
                                    value: dataColumn.charValue,
                                    recCharID: dataColumn.recCharID,
                                    valueID: valueID
                                };

                                charDataValues.push(charDataValue);
                            }

                            //var charDataValues: Models.ICharDataValue[] = [charDataValue];
                            this.charDatas[tagLabel] = charDataValues;

                            var selectedCharacteristicMetadata = _.find(this.templateMetaData.characteristicMetaDatas, (chr) => chr.characteristicID == charDataValue.charID);
                            filteredTemplateCharacteristicMetaDatas.push(selectedCharacteristicMetadata);
                        }
                    }
                }
            }
        }

        filteredTempalteMetaData = _.clone(this.templateMetaData, true);
        filteredTempalteMetaData.characteristicMetaDatas = filteredTemplateCharacteristicMetaDatas;

        this.selectedEntityCharData = {
            charDatas: this.charDatas,
            entityID: entityID,
            status: entityStatus,
            templateMetaData: filteredTempalteMetaData
        };
    }

    Save(isValid: boolean) {
        if (isValid) {
            var rowNumber = Utils.IdBuilder.splitEntityID(this.selectedEntityCharData.entityID).recID;
            var templateCharMDs = this.templateChars;
            var dateFormatSplits = this.selectedDateFormat.split("/");

            //This is hack in way. To convert dates from Edit form to whatever other format that user selected
            if (this.selectedDateFormat != "mm/dd/yyyy") {
                _.forEach(this.selectedEntityCharData.charDatas, function (value, key) {
                    var charMD = _.find(templateCharMDs, (chr) => chr.tagLabel == key);
                    if (charMD.dataTypeID == 5) {
                        if (value.length == 1) {
                            var dateCharDataLbl = value[0].value;
                            if (!_.isEmpty(dateCharDataLbl)) {
                                var formatedDateValue: string;
                                var dateValueSplits = dateCharDataLbl.split("/");
                                if (dateValueSplits.length == 3) {
                                    if (dateFormatSplits[0] == "yyyy") {
                                        formatedDateValue = dateValueSplits[2] + "/" + dateValueSplits[0] + "/" + dateValueSplits[1];
                                    }
                                    else if (dateFormatSplits[0] == "dd") {
                                        formatedDateValue = dateValueSplits[1] + "/" + dateValueSplits[0] + "/" + dateValueSplits[2];
                                    }
                                    else {
                                        formatedDateValue = dateCharDataLbl;
                                    }
                                }
                                else {
                                    formatedDateValue = dateCharDataLbl;
                                }
                                value[0].value = formatedDateValue;
                            }
                        }
                    }
                });
            }

            if (!this.isColumnEdit) {
                //Here we are updating a single entity and its char data                    
                this.notifyService.startProgress();

                this.bulkUploadService.saveStagingEntityCharData(this.token, this.selectedEntityCharData.entityID, this.selectedEntityCharData.charDatas, this.selectedDateFormat)
                    .then((result) => {
                        if (result) {

                            if (result.validationResult[rowNumber] == null) {
                                var currentRow = this.validationResults[rowNumber];
                                //console.log(currentRow);
                                _.forEach(this.selectedEntityCharData.charDatas, function (value, key) {

                                    var charDataLbl = "";
                                    if (value.length > 1) {
                                        charDataLbl = _.pluck(value, 'value').join("|");
                                    }
                                    else if (value.length == 1) {
                                        charDataLbl = value[0].value;
                                    }
                                    else {
                                        charDataLbl = "";
                                    }

                                    var moneyValue: Models.ICharDataMoneyValue = Utils.JsonUtil.Parse(charDataLbl, {});
                                    if (!_.isEmpty(moneyValue.locAmt)) {
                                        charDataLbl = moneyValue.locAmt;
                                    }

                                    var charMD = _.find(templateCharMDs, (chr) => chr.tagLabel == key);

                                    //console.log(charDataLbl);

                                    if (_.any(currentRow, cd => cd.characteristicID == charMD.characteristicID)) {
                                        var dataColumn = _.find(currentRow, d => d.characteristicID == charMD.characteristicID);
                                        dataColumn.charValue = charDataLbl;
                                        dataColumn.isValid = true;
                                    }
                                });
                            }
                            else {
                                var stagingEntityValidationResult: Models.IBulkUploadValidationResult[] = result.validationResult[rowNumber];
                                //this.validationResults[rowNumber] = result.validationResult[rowNumber];
                                var validationResults: Models.IBulkUploadValidationResult[] = [];
                                var rowValidationResult: { [key: number]: Models.IBulkUploadValidationResult[] } = {};
                                _.forEach(this.headerMappingRows, (hr) => {
                                    if (_.any(stagingEntityValidationResult, rr => rr.characteristicID == hr.characteristicID)) {
                                        var charValidationResult = _.find(stagingEntityValidationResult, rr => rr.characteristicID == hr.characteristicID);
                                        validationResults.push(charValidationResult);
                                    };
                                });
                                rowValidationResult[rowNumber] = validationResults;
                                this.validationResults[rowNumber] = validationResults;
                            }
                            this.notifyService.notifySuccess("Successfully Saved");
                        } else {
                            this.notifyService.notifyError("Error Saving");
                        }
                    })
                    .then(() => {
                        //this.RefreshValidationResult(Utils.IdBuilder.splitEntityID(this.selectedEntityCharData.entityID).recID);
                    })
                    .finally(() => {
                        this.notifyService.endProgress();
                        this.AreAllRowsValid();
                        this.editMode = false;
                    });
            }
            else {
                //Here we are updating all entity's chardata for selected characteristic. This is to update all chardata for any characteristic if User thinks that they had it wrong in the file to start with.                    
                this.SaveEntitiesCharData();
            }
        }
    }

    SaveEntitiesCharData() {
        var validationResultKeys = _.keys(this.validationResults).map((key) => _.parseInt(key));
        this.notifyService.startProgress();
        this.bulkUploadService.saveStatgingEntitiesCharData(this.token, validationResultKeys, this.selectedEntityCharData.entityID, this.selectedEntityCharData.charDatas)
            .then((result) => {
                if (result) {
                    this.notifyService.notifySuccess("Successfully Saved entire column");
                } else {
                    this.notifyService.notifyError("Error Saving");
                }
            })
            .finally(() => {
                this.SaveColumnData();
                this.AreAllRowsValid();
                this.editMode = false;
                this.notifyService.endProgress();
            });
    }

    Import() {
        var confirmClickMessage = "";
        if (this.mode == 1) {
            confirmClickMessage = "Are you sure you want to start Import?";
        }
        else {
            confirmClickMessage = "Are you sure you want to start Update?";
        }

        if (this.$window.confirm(confirmClickMessage)) {
            if (this.allRowsValid) {
                this.notifyService.startProgress(); // start progress bar
                var selectedItemIDs: number[] = [];
                if (this.selectedRecIdTitlePairs.length > 0) {
                    this.selectedRecIdTitlePairs.forEach((item) => {
                        selectedItemIDs.push(item.key);
                    });
                }

                this.bulkUploadService.doBulkUpload(this.selectedCharTypeID, this.selectedParentCharTypeID, selectedItemIDs, this.token, this.selectedAssociationCharTypeID, this.assocRelDirection, this.selectedFileName, this.mode, this.selectedDateFormat)
                    .then((result) => {
                        if (this.mode == 1) {
                            alert("Your records are now importing. You will receive an email notification once the job completes and all records have been made visible (re-indexed).  In the meantime, you can perform another import or leave this page and continue working elsewhere.");
                        }
                        else {
                            alert("Your records are now being updated. You will receive an email notification once the job completes and all records have been made visible (re-indexed).  In the meantime, you can perform another update or leave this page and continue working elsewhere.");
                        }
                    })
                    .catch((reason: any) => {
                        alert("busted");
                    })
                    .finally(() => {
                        this.Reset();
                        this.notifyService.endProgress();
                    });
            }
        }
    }

    SaveHeaderMapping() {
        this.savedHeaderMappingRow = _.cloneDeep(this.headerMappingRows);
        var currentHeaderMapping: Models.ISavedBulkUploadHeaderMapping = {
            mappingName: this.mappingName,
            charTypeID: this.selectedCharTypeID,
            templateID: this.selectedTemplateID,
            mappedHeaders: this.savedHeaderMappingRow
        };
        var storedHeaderMapping: Models.ISavedBulkUploadHeaderMapping[] = this.storage.get(this.savedBulkUploadHeaderMappingsKey) || [];
        if (_.any(storedHeaderMapping, mapping => mapping.mappingName == this.mappingName)) {
            var foundMapping = _.find(storedHeaderMapping, m => m.mappingName == this.mappingName);
            foundMapping.charTypeID = this.selectedCharTypeID;
            foundMapping.templateID = this.selectedTemplateID;
            foundMapping.mappedHeaders = this.savedHeaderMappingRow;
        }
        else {
            storedHeaderMapping.push(currentHeaderMapping);
        }
        this.storage.set(this.savedBulkUploadHeaderMappingsKey, storedHeaderMapping);
        this.mappingName = "";
        this.GetSavedHeaderMappings();
    }

    GetSavedHeaderMappings() {
        this.savedBulkUploadHeaderMappings = [];
        var storedHeaderMappings: Models.ISavedBulkUploadHeaderMapping[] = this.storage.get(this.savedBulkUploadHeaderMappingsKey) || [];

        if (storedHeaderMappings.length > 0) {
            _.forEach(storedHeaderMappings, (mapping) => {
                if (mapping.charTypeID == this.selectedCharTypeID && mapping.templateID == this.selectedTemplateID) {
                    this.savedBulkUploadHeaderMappings.push(mapping);
                }
            });
        }
    }

    UpdateHeaderMapping() {
        if (_.any(this.savedBulkUploadHeaderMappings, mapping => mapping.mappingName == this.selectedMapping.mappingName)) {
            var selectedHeaderMapping = _.find(this.savedBulkUploadHeaderMappings, mapping => mapping.mappingName == this.selectedMapping.mappingName);
            if (selectedHeaderMapping.charTypeID == this.selectedCharTypeID && selectedHeaderMapping.templateID == this.selectedTemplateID) {
                var selectedMappedHeaders = selectedHeaderMapping.mappedHeaders;
                var validationResultKeys = _.keys(this.validationResults).map((key) => _.parseInt(key));
                _.forEach(validationResultKeys, (key) => {
                    var validationResultHeaderRow = this.validationResults[key];
                    if (_.any(validationResultHeaderRow)) {
                        if (key == 0) {
                            for (var i = 0; i < validationResultHeaderRow.length; i++) {
                                var headerColumn = validationResultHeaderRow[i];
                                if (_.any(selectedMappedHeaders, m => m.charValue == headerColumn.charValue)) {
                                    var selectedMappedHeaderCol = _.find(selectedMappedHeaders, m => m.charValue == headerColumn.charValue);
                                    headerColumn.characteristicID = selectedMappedHeaderCol.characteristicID;
                                    headerColumn.isHidden = selectedMappedHeaderCol.isHidden;
                                    headerColumn.isValid = selectedMappedHeaderCol.isValid;
                                }
                            }
                        }
                        else {
                            for (var i = 0; i < validationResultHeaderRow.length; i++) {
                                var dataColumn = validationResultHeaderRow[i];
                                dataColumn.characteristicID = selectedMappedHeaders[i].characteristicID;
                                dataColumn.isHidden = selectedMappedHeaders[i].isHidden;
                                dataColumn.isValid = selectedMappedHeaders[i].isValid;
                            }
                        }
                    }
                });
                this.AreHeadersMapped();
            }
        }
    }

    ClearAllSavedMapping() {
        if (this.$window.confirm("Are you sure you want to clear out all Stores Mapping?")) {
            this.storage.set(this.savedBulkUploadHeaderMappingsKey, null);
        }
    }

    Delete(key: number) {
        if (this.$window.confirm("Are you sure you want to Delete this row?")) {
            this.notifyService.startProgress();
            var entityID = Utils.IdBuilder.buildEntityID(this.stgDivID, this.selectedCharTypeID, key);
            this.bulkUploadService.deleteStagingEntity(entityID, this.token)
                .then((result) => {
                    if (result) {
                        this.notifyService.notifySuccess("Successfully Deleted Record");
                        delete this.validationResults[key];
                    } else {
                        this.notifyService.notifyError("Error Deleting Record");
                    }
                })
                .then(() => {
                })
                .finally(() => {
                    this.AreAllRowsValid();
                    this.notifyService.endProgress();
                });
        }
    }

    IsInValidRow(key: number) {
        if (key > 0 && this.isFileDataValidated) {
            var currentValidationRow = this.validationResults[key];
            if (currentValidationRow != null) {
                var isValidRow = _.any(currentValidationRow, c => c.isValid == false);
                return isValidRow;
            }
        }
    }

    AreAllRowsValid() {
        var validationResultKeys = _.keys(this.validationResults).map((key) => _.parseInt(key));
        var anyError = true;
        _.forEach(validationResultKeys, (key) => {
            if (this.IsInValidRow(key)) {
                anyError = false;
            }
        });
        this.allRowsValid = anyError;
        this.showHeaderMapping = !this.allRowsValid;
    }

    EditColumnDatas(index: number) {
        this.selectedEntityCharData = null;
        this.charDatas = {};
        this.showMapColumnLOVs = false;
        this.columnHeaderIndex = index;
        this.editMode = false;
        var headerColumn = this.headerMappingRows[index];
        var headerColumnChar = _.find(this.templateChars, (chr) => chr.characteristicID == headerColumn.characteristicID);

        if (headerColumnChar.charValueSourceID != null && headerColumnChar.dataTypeID != Consts.CharDataTypeIDs.CharDataTypes.money) {
            this.mapColumnIndex = index;
            this.showMapColumnLOVs = true;
        }
        else {
            this.editMode = true;
            var entityID = Utils.IdBuilder.buildEntityID(this.stgDivID, this.selectedCharTypeID, 1);
            var filteredTempalteMetaData: Models.ICharacteristicMetaDataCollection = null;
            var filteredTemplateCharacteristicMetaDatas: Array<Models.ICharacteristicMetaData> = [];
            var valueID: number = 0;
            this.isColumnEdit = true;

            if (_.any(this.templateChars, (chr) => chr.characteristicID == headerColumn.characteristicID)) {
                //var headerColumnChar = _.find(this.templateChars, (chr) => chr.characteristicID == headerColumn.characteristicID);
                this.columnHeaderCharacteristicTagLabel = headerColumnChar.tagLabel;
                var tagLabel = headerColumnChar.tagLabel;

                var charDataValue: Models.ICharDataValue = {
                    charID: headerColumn.characteristicID,
                    value: "",
                    recCharID: 0,
                    valueID: valueID
                };

                var charDataValues: Models.ICharDataValue[] = [charDataValue];
                this.charDatas[tagLabel] = charDataValues;
                var selectedCharacteristicMetadata = _.find(this.templateMetaData.characteristicMetaDatas, (chr) => chr.characteristicID == headerColumn.characteristicID);
                filteredTemplateCharacteristicMetaDatas.push(selectedCharacteristicMetadata);
            }

            filteredTempalteMetaData = _.clone(this.templateMetaData, true);
            filteredTempalteMetaData.characteristicMetaDatas = filteredTemplateCharacteristicMetaDatas;

            this.selectedEntityCharData = {
                charDatas: this.charDatas,
                entityID: entityID,
                status: null,
                templateMetaData: filteredTempalteMetaData
            };
        }
    }

    MapColumnLOVs() {
        if (this.showMapColumnLOVs) {
            this.notifyService.startProgress();
            var headerColumn = this.headerMappingRows[this.mapColumnIndex];
            var headerColumnChar = _.find(this.templateChars, (chr) => chr.characteristicID == headerColumn.characteristicID);
            this.selectedColumnCharIDForMapping = headerColumnChar.characteristicID;
            this.selectedColumnCharValueSetID = headerColumnChar.charValueSetID;
            this.columnLOVs = [];
            this.selectedRecIDsForColLOVMapping = [];
            this.currentColumnLovMapping = {};
            var validationResultKeys = _.keys(this.validationResults).map((key) => _.parseInt(key));
            _.forEach(validationResultKeys, (key) => {
                if (key > 0) {
                    var dataRow = this.validationResults[key];
                    var dataColumn = _.find(dataRow, d => d.characteristicID == headerColumn.characteristicID);
                    if (!dataColumn.isValid) {
                        var dataValues = dataColumn.charValue;
                        this.selectedRecIDsForColLOVMapping.push(key);
                        var dataValueList = dataValues.split('|');
                        _.forEach(dataValueList, (dv) => {
                            if (!_.any(this.columnLOVs, fl => fl == dv)) {
                                this.columnLOVs.push(dv);
                            }
                        });
                    }
                }
            });

            var promise1 = this.entityConfigService.getCharacteristicValueList(headerColumnChar.charValueSetID)
                .then((results) => {
                    this.listValues = results;
                });

            var promise2 = this.entityConfigService.getCharacteristicValueHierarchyList(headerColumnChar.charValueSourceID)
                .then((results) => {
                    this.listRels = results;
                });

            return this.$q.all([promise1, promise2])
                .then(() => {
                    this.charValSourceListValues = [];
                    _.forEach(this.listRels, (lr) => {
                        if (_.any(this.listValues, lv => lv.charValueID == lr.charValueID)) {
                            var listValue: Models.ICharacteristicValue = _.find(this.listValues, lv => lv.charValueID == lr.charValueID);
                            this.charValSourceListValues.push(listValue);
                        }
                    });
                })
                .finally(() => {
                    this.GetSavedColumnLovMappings();
                    this.notifyService.endProgress();
                });
        }
    }

    SaveColumnData() {
        var dataColumns = this.validationResults;
        //var updatedCharDataValue = this.selectedEntityCharData.charDatas[this.columnHeaderCharacteristicTagLabel][0].value;
        var updatedCharDataValues = this.selectedEntityCharData.charDatas[this.columnHeaderCharacteristicTagLabel];
        var charDataLbl = "";
        if (updatedCharDataValues.length > 1) {
            charDataLbl = _.pluck(updatedCharDataValues, 'value').join("|");
        }
        else if (updatedCharDataValues.length == 1) {
            charDataLbl = updatedCharDataValues[0].value;
        }
        else {
            charDataLbl = "";
        }

        var updatedCharID = this.selectedEntityCharData.charDatas[this.columnHeaderCharacteristicTagLabel][0].charID;
        var validationResultKeys = _.keys(this.validationResults).map((key) => _.parseInt(key));
        var columnToUpdate = this.columnHeaderIndex;
        var charMetaData = this.selectedEntityCharData.templateMetaData.characteristicMetaDatas.find(chr => chr.characteristicID == updatedCharID);
        if (charMetaData.dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.money) {
            var moneyValue: Models.ICharDataMoneyValue = Utils.JsonUtil.Parse(charDataLbl, {});
            moneyValue.locAmt = moneyValue.locAmt.replace(/,/g, ''); //only works for US number formats
            if (!_.isNaN(parseFloat(moneyValue.locAmt))) {
                charDataLbl = moneyValue.locSym + ' ' + moneyValue.locAmt;
            }
        }


        _.forEach(validationResultKeys, (key) => {
            if (key > 0) {
                var dataRow = this.validationResults[key];
                var dataColumn = _.find(dataRow, d => d.characteristicID == updatedCharID);
                dataColumn.charValue = charDataLbl;
                dataColumn.isValid = true;
            }
        });
    }

    SaveColumnLOVMapping() {
        this.savedHeaderMappingRow = _.cloneDeep(this.headerMappingRows);
        var charMetaData = _.find(this.templateMetaData.characteristicMetaDatas, chr => chr.characteristicID == this.selectedColumnCharIDForMapping);
        var charValSourceID = charMetaData.charValueSourceID;

        var currentColLovMapping: Models.ISavedBulkUploadColumnLovMapping = {
            mappingName: this.lovMappingName,
            characteristicID: this.selectedColumnCharIDForMapping,
            mappedLovs: this.currentColumnLovMapping,
            charValSourceID: charValSourceID
        };

        var storedColumnLovMapping: Models.ISavedBulkUploadColumnLovMapping[] = this.storage.get(this.savedBulkUploadColumnLovMappingsKey) || [];

        if (_.any(storedColumnLovMapping, mapping => mapping.mappingName == this.lovMappingName)) {
            var foundMapping = _.find(storedColumnLovMapping, m => m.mappingName == this.lovMappingName);
            foundMapping.characteristicID = this.selectedColumnCharIDForMapping;
            foundMapping.mappedLovs = this.currentColumnLovMapping;
        }
        else {
            storedColumnLovMapping.push(currentColLovMapping);
        }

        this.storage.set(this.savedBulkUploadColumnLovMappingsKey, storedColumnLovMapping);
        this.lovMappingName = "";
        this.GetSavedColumnLovMappings();
    }

    ClearAllSavedColLovMapping() {
        if (this.$window.confirm("Are you sure you want to clear out all Stores LOV Mapping?")) {
            var updatedSavedBulkUploadColumnLovMappings: Models.ISavedBulkUploadColumnLovMapping[] = [];
            var charMetaData = _.find(this.templateMetaData.characteristicMetaDatas, chr => chr.characteristicID == this.selectedColumnCharIDForMapping);
            var charValSourceID = charMetaData.charValueSourceID;
            _.remove(this.savedBulkUploadColumnLovMappings, m => m.charValSourceID == charValSourceID);
            this.storage.set(this.savedBulkUploadColumnLovMappingsKey, this.savedBulkUploadColumnLovMappings);
            this.GetSavedColumnLovMappings();
        }
    }

    AreLOVsMapped() {
        var allLovsMapped: boolean = true;
        _.forEach(this.columnLOVs, (val) => {
            var valueMappedTo = this.currentColumnLovMapping[val];
            if (valueMappedTo == null) {
                allLovsMapped = false;
            }
        });

        this.validLOVMapping = allLovsMapped;
    }

    UpdateColumnLovMapping() {
        if (_.any(this.savedBulkUploadColumnLovMappings, mapping => mapping.mappingName == this.selectedColumnLovMapping.mappingName)) {
            var selectedColumnLovMapping = _.find(this.savedBulkUploadColumnLovMappings, mapping => mapping.mappingName == this.selectedColumnLovMapping.mappingName);
            var charMetaData = _.find(this.templateMetaData.characteristicMetaDatas, chr => chr.characteristicID == this.selectedColumnCharIDForMapping);
            var charValSourceID = charMetaData.charValueSourceID;
            if (selectedColumnLovMapping.charValSourceID == charValSourceID) {
                var selectedMappedLovs = selectedColumnLovMapping.mappedLovs;
                this.currentColumnLovMapping = {};

                _.forEach(this.columnLOVs, (val) => {
                    var valueMappedTo = selectedMappedLovs[val];
                    if (valueMappedTo != null) {
                        var selectedCharValueSourceListValue = _.find(this.charValSourceListValues, c => c.charValueID == valueMappedTo.charValueID);
                        this.currentColumnLovMapping[val] = selectedCharValueSourceListValue;
                    }
                });

                this.AreLOVsMapped();
            }
        }
    }

    GetSavedColumnLovMappings() {
        this.savedBulkUploadColumnLovMappings = [];
        var storedColumnLovMapping: Models.ISavedBulkUploadColumnLovMapping[] = this.storage.get(this.savedBulkUploadColumnLovMappingsKey) || [];
        var charMetaData = _.find(this.templateMetaData.characteristicMetaDatas, chr => chr.characteristicID == this.selectedColumnCharIDForMapping);
        var charValSourceID = charMetaData.charValueSourceID;

        if (storedColumnLovMapping.length > 0) {
            var storedLovMappingForCharValueSourceID = _.find(storedColumnLovMapping, m => m.characteristicID == this.selectedColumnCharIDForMapping);
            if (storedLovMappingForCharValueSourceID == null) {
                storedLovMappingForCharValueSourceID = _.find(storedColumnLovMapping, m => m.charValSourceID == charValSourceID);
                if (storedLovMappingForCharValueSourceID != null) {
                    this.savedBulkUploadColumnLovMappings.push(storedLovMappingForCharValueSourceID);
                }
            }
            else {
                this.savedBulkUploadColumnLovMappings.push(storedLovMappingForCharValueSourceID);
            }
        }
    }

    UpdateStgRecordsWithColumnLOVMapping() {
        var jsonLovMapping: { [key: string]: string } = {};
        var curColLovMappingKeys = _.keys(this.currentColumnLovMapping);
        _.forEach(curColLovMappingKeys, (key) => {
            var item = this.currentColumnLovMapping[key];
            jsonLovMapping[key] = item.charValueID.toString();
        });

        this.notifyService.startProgress();
        this.bulkUploadService.updateStagingEntitiesCharDataLov(this.token, this.selectedCharTypeID, this.selectedRecIDsForColLOVMapping, this.selectedColumnCharIDForMapping, this.selectedColumnCharValueSetID, Utils.JsonUtil.Stringify(jsonLovMapping))
            .then((result) => {
                if (result.data) {
                    var headerColumnChar = _.find(this.templateChars, (chr) => chr.characteristicID == this.selectedColumnCharIDForMapping);
                    _.forEach(this.selectedRecIDsForColLOVMapping, (stgRecID) => {
                        var dataRow = this.validationResults[stgRecID];
                        var dataColumn = _.find(dataRow, d => d.characteristicID == this.selectedColumnCharIDForMapping);
                        var mappedItem: Models.ICharacteristicValue;
                        if (headerColumnChar.multipleIndicator) {
                            var charValueLbls = dataColumn.charValue.split("|");
                            var updatedCharValueLbls: string[] = [];
                            _.forEach(charValueLbls, (chrv) => {
                                mappedItem = this.currentColumnLovMapping[chrv];
                                updatedCharValueLbls.push(mappedItem.charValueLabel);
                            });
                            dataColumn.charValue = updatedCharValueLbls.join("|");
                        }
                        else {
                            mappedItem = this.currentColumnLovMapping[dataColumn.charValue];
                            dataColumn.charValue = mappedItem.charValueLabel;
                        }
                        dataColumn.isValid = true;
                    });
                    this.notifyService.notifySuccess("Successfully updated all Records with newly mapped LOV.");
                }
                else {
                    this.notifyService.notifyError("Error updating Record Char Data.");
                }
            })
            .finally(() => {
                this.showMapColumnLOVs = false;
                this.selectedColumnCharIDForMapping = 0;
                this.columnLOVs = [];
                this.selectedRecIDsForColLOVMapping = [];
                this.AreAllRowsValid();
                this.notifyService.endProgress();
            });
    }

    private ConvertDateValueToUSDateFormat(charDataValue: string): string {
        let formatedDateValue: string;
        if (this.selectedDateFormat == "mm/dd/yyyy") {
            formatedDateValue = charDataValue;
        }
        else {
            var dateFormatSplits = this.selectedDateFormat.split("/");
            var dateValueSplits = charDataValue.split("/");
            if (dateValueSplits.length == 3) {
                if (dateFormatSplits[0] == "yyyy") {
                    formatedDateValue = dateValueSplits[1] + "/" + dateValueSplits[2] + "/" + dateValueSplits[0];
                }
                else if (dateFormatSplits[0] == "dd") {
                    formatedDateValue = dateValueSplits[1] + "/" + dateValueSplits[0] + "/" + dateValueSplits[2];
                }
                else {
                    formatedDateValue = charDataValue;
                }
            }
            else {
                formatedDateValue = charDataValue;
            }
        }
        return formatedDateValue;
    }

    private ConvertDateCharValueToSelectedDateFormat(charDataValue: string): string {
        let formatedDateValue: string;
        if (this.selectedDateFormat == "mm/dd/yyyy") {
            formatedDateValue = charDataValue;
        }
        else {
            var dateFormatSplits = this.selectedDateFormat.split("/");
            var dateValueSplits = charDataValue.split("/");
            if (dateValueSplits.length == 3) {
                if (dateFormatSplits[0] == "yyyy") {
                    formatedDateValue = dateValueSplits[2] + "/" + dateValueSplits[0] + "/" + dateValueSplits[1];
                }
                else if (dateFormatSplits[0] == "dd") {
                    formatedDateValue = dateValueSplits[1] + "/" + dateValueSplits[0] + "/" + dateValueSplits[2];
                }
                else {
                    formatedDateValue = charDataValue;
                }
            }
            else {
                formatedDateValue = charDataValue;
            }
        }
        return formatedDateValue;
    }

}
